"use client";

import React, { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheArtistBehindTheLens() {
  const [offsetY, setOffsetY] = useState(0);
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  useEffect(() => {
    const handleScroll = () => {
      setOffsetY(window.scrollY * 0.15);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section data-section-id="222204" id="brands" className="bg-background text-foreground relative overflow-hidden min-h-screen w-full flex flex-col lg:flex-row">
      {}
      <div className="relative w-full lg:w-[55%] h-[60vh] lg:h-screen overflow-hidden shrink-0">
        <div className="absolute inset-0 w-full h-[120%] -top-[10%]" style={{
        transform: `translateY(${offsetY}px)`,
        transition: "transform 0.1s ease-out"
      }}>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679158/img/endurance_athlete_performance_hero.png" alt="Endurance athletes in action" className="w-full h-full object-cover object-center" />
        </div>

        {}
        <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(circle_at_center,transparent_40%,rgba(102,204,51,0.1)_100%)] mix-blend-overlay"></div>
        <div className="absolute inset-0 pointer-events-none bg-gradient-to-t from-background via-background/40 to-transparent lg:bg-gradient-to-r lg:from-transparent lg:via-background/80 lg:to-background"></div>
      </div>

      {}
      <div className="relative w-full lg:w-[45%] flex items-center justify-center p-8 lg:p-16 z-10 -mt-20 lg:mt-0">
        <div ref={contentRef} className={`max-w-xl flex flex-col items-center lg:items-start text-center lg:text-left transition-all duration-1000 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <span className="font-default text-lg font-semibold tracking-widest uppercase mb-4 text-primary">BRANDS</span>
          <h1 className="font-default text-6xl md:text-8xl lg:text-[56px] font-bold tracking-tighter text-foreground leading-[1.1] mb-4">WE HAVE THE ENDURANCE ATHLETES.</h1>
          <h2 className="font-default text-xl md:text-2xl font-semibold leading-tight text-foreground text-center lg:text-left mb-6">Endurance Sports Advertising Powered by Real Athlete Intent.</h2>
          <p className="text-muted-foreground text-lg md:text-xl leading-relaxed mb-10 max-w-md">Reach endurance athletes based on real-time behavior.<br /><br />ESMG turns live behavioral signals from leading endurance platforms into continuously refreshed audiences brands can activate in the advertising platforms they already use.</p>

          <div className="flex flex-col sm:flex-row items-center gap-4 w-full sm:w-auto">
            <Button asChild size="lg" className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive shadow-xs h-10 px-6 has-[>svg]:px-4 w-full sm:w-auto rounded-md hover:bg-primary/90 font-semibold text-primary bg-primary">
              
            </Button>
            
            <Button asChild variant="outline" size="lg" className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm transition-all [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive shadow-xs h-10 px-6 has-[>svg]:px-4 w-full rounded-md border-primary font-semibold !opacity-[1] border-1 border-solid !text-[rgba(72,255,28,1)] !border-[rgba(30,32,30,1)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 dark:bg-input/30 dark:border-input dark:hover:bg-input/50 sm:w-auto hover:bg-primary hover:text-primary-foreground bg-ring">
              
            </Button>
          </div>
        </div>
      </div>
    </section>;
}